import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import formdata from './formdata'

const state = {
    data: {
        street:'',
        zip:'',
        city:'',
        country:'',
        latitude:0.0,
        longitude:0.0
    },
    adresses:[],
    
    
};

export default {
    modules: {
        formdata: formdata,
        
    },
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};